import React, { useState } from 'react';
import { decodeHTML } from 'entities';
import { notify } from '../../../../helpers/notifications';

const TextValue = ({
  field,
  response,
  isEditing,
  adminField,
  handleTextResponseUpdate,
}) => {
  const [text, setText] = useState(
    response && response.value ? decodeHTML(response.value) : ''
  );
  let width = field.width === 1 ? 'full' : field.width === 2 ? 'half' : 'third';
  // If the field is "Parent Email [Auto]", we want to change the label to "Validation Email [Auto]"
  const changeFieldName = field.name === 'Parent Email [Auto]';

  const handleSave = (e) => {
    handleTextResponseUpdate(e, response).then((newValue) => {
      let htmlSafeValue = newValue ? decodeHTML(newValue) : '';
      if (htmlSafeValue != text) {
        notify.info('Note: HTML tags or extra spaces have been removed', {
          showOnlyTheLastOne: false,
          timeout: 6000,
        });
        setText(htmlSafeValue);
      }
    });
  };

  return (
    <div className={'input-group ' + width}>
      <label
        className={
          response?.value?.length > 0 || isEditing || adminField ? '' : 'empty'
        }
      >
        {(changeFieldName ? 'Validation Email [Auto]' : field.name) + ': '}
      </label>
      {adminField && field.help_text && (
        <p className='admin-help-text'>{field.help_text}</p>
      )}
      {isEditing || adminField ? (
        <div className='text-input'>
          <input
            type='text'
            value={text}
            onChange={(e) => setText(e.target.value)}
            onBlur={(e) => handleSave(e)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') handleSave(e);
            }}
            placeholder={
              adminField && field.placeholder ? field.placeholder : ''
            }
          />
        </div>
      ) : response?.value ? (
        decodeHTML(response.value)
      ) : (
        ''
      )}
    </div>
  );
};

export default TextValue;
